import cx from 'classnames';
import { FC } from 'react';
import { Conditional, Map, MapMarker } from '../common';
import styles from './StoreLocationMap.module.scss';
import { CAT_POI_ICON } from './constants';
import { StoreLocationMapProps } from './types';

export const StoreLocationMap: FC<StoreLocationMapProps> = ({
  userCountryCode,
  dealerCode,
  latitude,
  longitude,
  className,
  onClick
}) => {
  const coordinates = { lat: latitude, lng: longitude };
  const showStoreLocationMap = !!(longitude && latitude);
  const content = document.createElement('img');
  content.src = CAT_POI_ICON;

  return (
    <Conditional test={showStoreLocationMap}>
      <div
        data-testid="location-map"
        className={cx(styles['store-location-map-container'], className)}
      >
        <Map
          userCountryCode={userCountryCode}
          dealerCode={dealerCode}
          center={coordinates}
          mapOptions={{
            clickableIcons: false,
            fullscreenControl: false,
            zoomControl: false,
            zoom: 10
          }}
        >
          <MapMarker
            position={coordinates}
            content={content}
            onClick={onClick}
          />
        </Map>
      </div>
    </Conditional>
  );
};
